<template>
    <HeroSection :featureName="baseFeature.name" :icon="baseFeature.icon">
        <template #title>{{ baseFeature.description }}</template>
        <template #description>
            <div>Track attendance in real time and manage capacity in real time.</div>
            <div class="mt-4">Scan badges or allow attendees to self-scan to track attendance.</div>
        </template>
        <template #content>
            <CmsAndApp :webImage="webImage" :appImage="appImage" />
        </template>
    </HeroSection>

    <WatchThisSpace />

    <Tips :title="baseFeature.name" :tips="tips" />
    <WorksWith :title="baseFeature.name" :integrations="integrations" />
    <Cta />

</template>

<script setup>
import Cta from '../../components/Blocks/Cta.vue';
import HeroSection from '../../components/HeroSection.vue';
import CmsAndApp from '../../components/Layouts/CmsAndApp.vue';
import Tips from '../../components/Blocks/Tips.vue';
import WatchThisSpace from '../../components/Blocks/WatchThisSpace.vue';
import WorksWith from '@/components/Blocks/WorksWith.vue';
import { getFeaturesByIds } from '../../router/features';

import webImage from '@/images/screenshots/cms/session-edit.png';
import appImage from '@/images/screenshots/app/theme-1/session.png';

const tips = [
    'Setup your tracking rules based on your event security requirements. If capacity is limited, or required specific ticket types, use Staff tracking.',
];

const baseFeature = getFeaturesByIds(['attendancetracking'])[0];
const integrations = getFeaturesByIds(['eventapp', 'badgesandkiosks', 'speakerportals']);
</script>